import { createApp } from 'vue'
import App from './App.vue'
import './index.css'
import router from './router/index'
import ElementPlus from 'element-plus'
import zhElementPlus from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)
app.use(router)
app.use(ElementPlus, { locale: zhElementPlus })
app.mount('#app')
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}